//Core
import React from "react"

//Images
import cardPudra from "../.././../images/pudra.svg"

import { classes } from "../../../helpers/classname"

import ListWithBullet from "../../../components/ListWithBullet"

//Style
import style from "./style.module.scss"
import formStyle from "../FormPudra/style.module.scss"
import jump from "jump.js"

const { Button } = formStyle

const {
  Container,
  Wrapper,
  TextWrapper,
  title,
  subtitle,
  small,
  Image,
  button,
  bonus,
  FormWrapper,
  Feature,
  info,
} = style

const list = [
  `5% кешбеку на одяг та взуття `,
  `3% на косметику та салони краси`,
]

const listTextStyle = {
  color: "#131d5b",
  fontWeight: "700",
  fontFamily: "Roboto",
  fontSize: "20px",
}

const Header = () => {
  return (
    <div className={Container}>
      <div className={Image}>
        <img
          src={cardPudra}
          alt="#PudraCard Таскомбанк"
          // className={image}
        ></img>
      </div>
      <div className={Wrapper}>
        <div className={TextWrapper}>
          <h1 className={title}>ТВОЯ НАЙКРАЩА</h1>
          <h2 className={classes(small, title)}> КАРТКА ДЛЯ ШОПІНГУ!</h2>
          <h2 className={info}>
            {`Дякуємо, що прийняла запрошення від подружки :-)`}
          </h2>

          <div className={Feature}>
            <h2 className={subtitle}>
              {`Оформи #PudraCard зараз і насолоджуйся шопінгом з:`}
            </h2>
            <ListWithBullet
              color="#bb2852"
              list={list}
              textStyle={listTextStyle}
            ></ListWithBullet>
          </div>

          <h3 className={bonus}>
            А ще ти та твоя подружка отримаєте по 50 грн!
          </h3>
          <button
            className={classes(Button, button)}
            onClick={() => jump("#form", { offset: -130 })}
          >
            Замовити картку
          </button>
        </div>
      </div>
    </div>
  )
}

export default Header
